import { Action } from "@ngrx/store";
import { type BackgroundItem } from "./backgrounds.interface";

export const GET_BACKGROUNDS = "GET_BACKGROUNDS";
export const GET_BACKGROUNDS_SUCCESS = "GET_BACKGROUNDS_SUCCESS";
export const GET_BACKGROUNDS_FAILURE = "GET_BACKGROUNDS_FAILURE";

export const DELETE_BACKGROUND = "DELETE_BACKGROUND";
export const DELETE_BACKGROUND_SUCCESS = "DELETE_BACKGROUND_SUCCESS";
export const DELETE_BACKGROUND_FAILURE = "DELETE_BACKGROUND_FAILURE";

export class GetBackgroundsAction implements Action {
  readonly type = GET_BACKGROUNDS;

  constructor(public payload: { mine: boolean }) {}
}

export class GetBackgroundsSuccessAction implements Action {
  readonly type = GET_BACKGROUNDS_SUCCESS;

  constructor(public payload: BackgroundItem[]) {}
}

export class GetBackgroundsFailureAction implements Action {
  readonly type = GET_BACKGROUNDS_FAILURE;

  constructor(public payload: unknown) {}
}

export class DeleteBackgroundAction implements Action {
  readonly type = DELETE_BACKGROUND;

  constructor(public payload: string) {}
}

export class DeleteBackgroundSuccessAction implements Action {
  readonly type = DELETE_BACKGROUND_SUCCESS;

  constructor(public payload: string) {}
}

export class DeleteBackgroundFailureAction implements Action {
  readonly type = DELETE_BACKGROUND_FAILURE;

  constructor(public payload: unknown) {}
}

export type BackgroundsActions =
  | GetBackgroundsAction
  | GetBackgroundsSuccessAction
  | GetBackgroundsFailureAction
  | DeleteBackgroundAction
  | DeleteBackgroundSuccessAction
  | DeleteBackgroundFailureAction;
